import { Flex } from "@chakra-ui/react";
import { IRootProps } from "../interfaces";

export default function LayoutGerenciadorContent({ children }: IRootProps) {
  return (
    <Flex id="body-ger" display={"flex"} flexDirection={"column"}>
      {children}
    </Flex>
  );
}
